import { Component, OnInit, Input } from '@angular/core';
import { UtilService } from '../../services/util.service';

@Component({
    selector: 'date-time-view',
    templateUrl: './date-time-view.component.html',
    styleUrls: ['./date-time-view.component.scss'],
    standalone: false
})
export class DateTimeViewComponent implements OnInit {
  @Input() value: any;
  @Input() type: any;
  @Input() outPutFormat: any;
  constructor(public utilService: UtilService) { }

  ngOnInit() {
  }
  setData(value, type){
    let str = ''
    if(value != undefined){
      for(var i=0;i<value.length;i++){
        if(type == 'dateTimeFormat')
          str += this.utilService.toTimeZoneDateFormat(value[i], 'datetime') + ' -';
        else if(type == 'dateFormat')
          str += this.utilService.toTimeZoneDateFormat(value[i], 'date') + ' -';
      }
      return str.substring(0, str.length - 1);
    }
  }
}
